import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faArrowRight,
  faCircleInfo,
  faExclamationCircle,
} from '@fortawesome/pro-solid-svg-icons';

export default library.add(faArrowRight, faCircleInfo, faExclamationCircle);
